import SchoolPeriodEdit from './SchoolPeriodEdit'
import SchoolPeriodList from './SchoolPeriodList'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: SchoolPeriodList,
    edit: SchoolPeriodEdit
}
